import { useContext } from "react";
import ProjectCommandContext from "../contexts/ProjectCommandContext";

const useProjectCommands = () => {
  return useContext(ProjectCommandContext);
};

export default useProjectCommands;
